import PropTypes from 'prop-types';

import {Rect as FabricRect} from 'fabric';

import {limitReached} from '../canvas-helper';

const Rect = ({canvas, stroke, width, fill = ''}) => {
    let isDrawing = false;
    let rect = null;
    let initialLeft;
    let initialTop;

    canvas.on('mouse:down', (o) => {
        if (limitReached(canvas)) {
            return;
        }

        // don't draw if an object is selected on the canvas
        if (canvas.getActiveObject()) {
            return;
        }

        isDrawing = true;
        let pointer = canvas.getScenePoint(o.e);
        initialLeft = pointer.x;
        initialTop = pointer.y;
        rect = new FabricRect({
            strokeWidth: width,
            fill: fill,
            stroke: stroke,
            left: initialLeft,
            top: initialTop,
            hasBorders: false,
            hasControls: false,
        });
        canvas.add(rect);
    });

    canvas.on('mouse:move', (o) => {
        if (!isDrawing) {
            return;
        }

        let pointer = canvas.getScenePoint(o.e);

        if (initialLeft > pointer.x) {
            rect.set({left: Math.abs(pointer.x)});
        }

        if (initialTop > pointer.y) {
            rect.set({top: Math.abs(pointer.y)});
        }

        rect.set({
            width: Math.abs(initialLeft - pointer.x),
            height: Math.abs(initialTop - pointer.y)
        });
        canvas.renderAll();
    });

    canvas.on('mouse:up', () => {
        isDrawing = false;

        if (rect) {
            if (rect.width < 10 && rect.height < 10) {
                canvas.remove(rect);
                rect = null;
                canvas.renderAll();
                return;
            }

            canvas.remove(rect);
            canvas.add(rect);
            canvas.sendObjectToBack(rect);
        }
    });

};

Rect.propTypes = {
    canvas: PropTypes.object.isRequired
};

export default Rect;